module.exports = __webpack_public_path__ + "img/1641676205321.fc8d59bc.jpg";